/**
 * @package   ScandiPWA\GtmGraphQl
 * @author    Abdelrahman Hady <abdelrahman.hady@scandiweb.com>
 * @copyright Copyright (c) 2023 Scandiweb, Inc (https://scandiweb.com)
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 */

import Event, { EVENT_GTM_ADD_TO_WISHLIST_GA4 } from '../../util/Event';

/** @namespace ScandiPWA/GtmGraphQl/Plugin/Event-dispatches/Plugin/addItemToWishlist */
export const addItemToWishlist = (args, callback) => {
    const [, wishlistItem] = args;

    return callback(...args)
        .then(
            /** @namespace ScandiPWA/GtmGraphQl/Plugin/Event-dispatches/Plugin/callbackThen */
            () => {
                Event.dispatch(EVENT_GTM_ADD_TO_WISHLIST_GA4, wishlistItem);
            }
        );
};

export default {
    'Store/Wishlist/Dispatcher': {
        'member-function': {
            addItemToWishlist
        }
    }
};
